import { type DefaultRootState } from 'react-redux';

const folderHasNext = (spaceId: number, folderId: string | number | 'root') => (state: DefaultRootState) => {
  return state.spaceResource.pagination[spaceId]?.[folderId]?.hasNext ?? false;
};

export default folderHasNext;
